import styled from 'styled-components';
import {Space} from 'antd';
import {typographyStyles} from '../../../../utils/styles';

const StyledBudgetSelector = styled.div`
  width: 100%;

  & > div {
    &:last-of-type {
      margin-top: 16px;
    }
  }
`;

const StyledBudgetSelectorItem = styled(Space)`
  width: 100%;
`;

const StyledBudgetSelectorItemTitle = styled.div`
  ${typographyStyles.body.regular};
  color: ${props => props.theme.colors.neutral_10};
  display: flex;
  justify-content: space-between;

  .amount {
    ${typographyStyles.body.medium};
    margin-left: 8px;
    text-wrap: nowrap;
  }
`;

const StyledBudgetSelectorItemDate = styled.div`
  ${typographyStyles.footnote.description};
  color: ${props => props.theme.colors.neutral_7};
`;

const StyledBudgetSelectorItemDateTag = styled.span`
  ${typographyStyles.footnote.description};
  background-color: ${props => props.theme.colors.neutral_2};
  border-radius: 10px;
  display: inline-block;
  padding: 0 6px;
  color: ${props => props.theme.colors.neutral_7};
  line-height: 20px;
`;

const StyledBudgetSelectorFilterSpace = styled(Space)`
  padding: 8px 0;

  & > .ant-space-item {
    width: 100%;
  }

  .budget-selector-filters {
    display: flex;
    flex-direction: column;
    margin-bottom: 0;

    & > .ant-space-item {
      width: 100%;
    }
  }

  .transaction-matching-panel-filters-right-space {
    flex-direction: row-reverse;

    & > .ant-space-item {
      width: 50%;
    }

    .ant-picker {
      width: 100%;
    }
  }
`;

const StyledBudgetSelectorResults = styled.div`
  min-height: 85px;
`;

export {
  StyledBudgetSelector,
  StyledBudgetSelectorItem,
  StyledBudgetSelectorItemTitle,
  StyledBudgetSelectorItemDate,
  StyledBudgetSelectorItemDateTag,
  StyledBudgetSelectorFilterSpace,
  StyledBudgetSelectorResults
}
